import Vue from 'vue';

export default Vue.component('doclink', {
    props: {
        n: String, // name (that we're looking up the definition for)
        t: String,  // target (html anchor) for the topic, if different from the name
        p: {type: String, required: true},   // page
    },
    data: function() {
        let target = this.n ? `#${this.n.trim().toLowerCase()}` : '' 
        if (target.endsWith("s")) target = target.slice(0,-1) // remove any trailing "s"" so that you can use plurals ie 'n="track"' and 'n="tracks"'
        target = target.replace(/ /g, "") // also ignore spaces in the target, eg 'n="Hamburger menu"'

        const text = this.t || this.n || this.p // use the text if it's provided. If not, use the ref. If that's not provided, the page (which is mandatory).

        return { 
            glTarget: `./${this.p}${target}`,
            glText: text
        }
    }
});
